(() => {
  const main = document.querySelector('#MainContent');
  if (!main || !document.body.hasAttribute('data-nny-product-highlights')) return;
  const richtext = '.tab-panels [role="tabpanel"], .np-richtext, .rte';
  const excluded = 'button, input, select, textarea, [role="button"], .nny-editor-hint, .nny-profile-editor, .np-review-card, [data-nny-no-highlight]';
  const marked = new WeakSet();
  const reveal = element => element.classList.add('is-marked');
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    for (const entry of entries) {
      if (!entry.isIntersecting) continue;
      reveal(entry.target);
      observer.unobserve(entry.target);
    }
  }, {threshold: 0, rootMargin: '0px 0px -24px 0px'}) : null;

  const scan = root => {
    if (root.nodeType === Node.TEXT_NODE) root = root.parentElement;
    if (!(root instanceof Element)) return;
    const candidates = [...root.querySelectorAll('strong, b')];
    if (root.matches('strong, b')) candidates.unshift(root);
    for (const element of candidates) {
      if (!element.textContent.trim() || !element.closest(richtext) || element.closest(excluded)) continue;
      if (element.parentElement.closest('strong, b')) continue;
      if (marked.has(element)) {
        if (!element.classList.contains('is-marked')) observer?.observe(element);
        continue;
      }
      marked.add(element);
      element.style.setProperty('--nny-marker-original-color', getComputedStyle(element).color);
      element.classList.add('nny-bold-marker');
      if (observer) observer.observe(element);
      else reveal(element);
    }
  };

  scan(main);
  const mutations = new MutationObserver(records => {
    for (const record of records) {
      for (const node of record.removedNodes) {
        if (!(node instanceof Element)) continue;
        if (!node.isConnected) observer?.unobserve(node);
        node.querySelectorAll('.nny-bold-marker').forEach(element => {
          if (!element.isConnected) observer?.unobserve(element);
        });
      }
      for (const node of record.addedNodes) scan(node);
    }
  });
  mutations.observe(main, {childList: true, subtree: true});
  document.addEventListener('shopify:section:load', event => scan(event.target));
})();
